<template>
  <v-container class="ma-2 pa-0" style="height: 100%">
    <v-col cols="12" justify="center" class="ma-0 pa-0">
      <v-alert type="info" class="ma-0 pa-2" :class="isOnMobile ? '' : 'mr-8'" dense dismissible>
        <v-row class="ma-2 pa-0">
          <span style="text-align: justify">За плащане по банков път към Тремол ООД, моля използвайте посочените по-долу данни.</span>
        </v-row>
      </v-alert>
      <div class="pa-2 ma-2" align-items="center" flat>
        <v-row>
          <v-col>
            <v-form class="ma-0 pa-0" ref="refValidationForm" lazy-validation>
              <v-row class="ma-2 pa-0">
                <v-text-field style="max-width: 100px" outlined class="ma-0 pr-2 centered-input" type="number" maxlength="10" label="Сума" v-model.number="amount" :rules="[...global_rules.money]" dense></v-text-field>
                <t-button :btnText="'Генерирай основание за плащане'" :btnIcon="'mdi-bank-transfer'" @click.native="generate()" />
              </v-row>
            </v-form>
            <v-row class="ma-2 pa-0" v-if="user && reason">
              <v-icon class="mr-2" size="20" @click="copyAndShow('Тремол ООД')">mdi-content-copy</v-icon>
              <span>"Тремол" ООД</span>
            </v-row>
            <v-row class="ma-2 pa-0" v-if="user && reason">
              <v-icon class="mr-2" size="20" @click="copyAndShow('104593442')">mdi-content-copy</v-icon>
              <span>ЕИК: 104593442</span>
            </v-row>
            <v-row class="ma-2 pa-0" v-if="user && reason">
              <v-icon class="mr-2" size="20" @click="copyAndShow('BG81STSA93000000222896')">mdi-content-copy</v-icon>
              <span>IBAN: BG81STSA93000000222896</span>
            </v-row>
            <v-row class="ma-2 pa-0" v-if="user && reason">
              <v-icon class="mr-2" size="20" @click="copyAndShow('STSABGSF')">mdi-content-copy</v-icon>
              <span>BIC: STSABGSF</span>
            </v-row>
            <v-row class="ma-2 pa-0" v-if="user && reason">
              <v-icon class="mr-2" size="20" @click="copyAndShow(reason)">mdi-content-copy</v-icon>
              <span>{{ "Основание: " + reason }}</span>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import { TR } from "../../main";
export default {
  data() {
    return {
      user: null,
      amount: 0,
      reason: "",
    };
    //ОСНОВАНИЕ TODO
  },
  methods: {
    setFocus(on) {
      if (on) {
        this.user = DataManager.getData(DataManager.DataType.user);
        var txt = "";
        if (!this.user.invCompanyName) {
          txt = "Необходимо е да въведете данни за фактура.\nЩе бъдете пренасочени към съответното меню.";
        } else if ("BG" + this.user.invEik != this.user.invZDDSnom && this.user.invEik != this.user.invZDDSnom) {
          txt = "Въведените булстат и номер по ЗДДС не кореспондират.\nЩе бъдете пренасочени, за да потвърдите данните.";
        }
        if (txt) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.dialog.show(
                "yes-no",
                null,
                {
                  title: "Внимание",
                  buttonYesText: "Ок",
                  text: txt,
                },
                (result) => {
                  if (result) {
                    this.$router.push({ path: "/" + TR.Locale + "/invoiceData" });
                  }
                },
              );
            });
          }, 500);
        }
      }
    },
    setTitleAndData(meta, error) {
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(meta.datatype);
      }
    },
    copyAndShow(txt) {
      txt.copyToClipboard();
      this.dialogLoader.showInfo("Текста е копиран в клипборда.", { timeout: 2000, location: "center" });
    },
    generate() {
      if (this.$refs.refValidationForm.validate()) {
        if (this.amount < 5) {
          this.dialogLoader.showError("Минималната сума за внасяне е 5 " + TR.MoneyAbbreviation, { location: "center" });
          return;
        }
        DataManager.generatePaymentReason({ amount: this.amount }, (err, resp) => {
          if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            this.reason = resp.code;
          } else {
            this.dialogLoader.hide();
            this.dialogLoader.showError("Грешка! " + err.Message, { timeout: 5000, location: "center" });
          }
        });
      } else {
        this.dialogLoader.showError("Невалида сума!", { location: "center" });
      }
    },
  },
  mounted() {},
};
</script>

<style>
</style>